var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg48IconRead(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-641 -352.5)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    transform: "translate(641 352.5)",
    fill: "#f4f3f0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-420.273 -348.471)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.279,45.5h5.9a5.47,5.47,0,0,1,3.523,1.3,5.684,5.684,0,0,1,.718.729,5.68,5.68,0,0,1,.719-.729,5.474,5.474,0,0,1,3.525-1.3h5.917a3.354,3.354,0,0,1,3.257,3.4V59.883a3.343,3.343,0,0,1-3.279,3.4h-3.79c-4.047,0-4.614.963-5.018,2.432a1.383,1.383,0,0,1-1.335,1.014h0A1.372,1.372,0,0,1,11.084,65.7c-.4-1.462-.972-2.42-5.015-2.42H2.279A3.343,3.343,0,0,1-1,59.883V48.9A3.343,3.343,0,0,1,2.279,45.5Zm10.146,6.091A1.251,1.251,0,0,1,11.2,50.6,3.147,3.147,0,0,0,8.183,48h-5.9A.843.843,0,0,0,1.5,48.9V59.883a.843.843,0,0,0,.777.894H6.07a9.966,9.966,0,0,1,5.137,1,4.539,4.539,0,0,1,1.214,1.04,4.385,4.385,0,0,1,1.217-1.04,9.959,9.959,0,0,1,5.134-1h3.79a.843.843,0,0,0,.777-.894V48.9a.85.85,0,0,0-.771-.9h-5.9a3.14,3.14,0,0,0-3.018,2.6A1.25,1.25,0,0,1,12.425,51.591Z",
    transform: "translate(432.273 317.971)",
    fill: "#816920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,1.277H.213a1.063,1.063,0,0,1,0-2.127H6.3a1.063,1.063,0,0,1,0,2.127Z",
    transform: "translate(447.249 370.666)",
    fill: "#816920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,1.277H.213a1.063,1.063,0,0,1,0-2.127H6.3a1.063,1.063,0,0,1,0,2.127Z",
    transform: "translate(447.249 374.723)",
    fill: "#816920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,1.277H.213a1.063,1.063,0,0,1,0-2.127H6.3a1.063,1.063,0,0,1,0,2.127Z",
    transform: "translate(435.566 370.666)",
    fill: "#816920"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.3,1.277H.213a1.063,1.063,0,0,1,0-2.127H6.3a1.063,1.063,0,0,1,0,2.127Z",
    transform: "translate(435.566 374.723)",
    fill: "#816920"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg48IconRead);
export default __webpack_public_path__ + "static/media/48-icon-read.e7600f80.svg";
export { ForwardRef as ReactComponent };